import { observer } from "mobx-react-lite"

import { MessageBox } from "@/domains/common/components/message-box"
import { cn } from "@/domains/library"
import { ILiquidityPool } from "@/domains/pools/types"

export const AprColumn = observer(({ isCompact, pool }: { isCompact: boolean; pool: ILiquidityPool }) => {
  if (isCompact) {
    return (
      <MessageBox
        variant={"success"}
        className={cn("w-full justify-center whitespace-nowrap bg-p500 text-end", "h-fit", "border-none")}
        showIcon={false}
      >
        <div className={"text-t100"}>{pool.displayApr}</div>
        <div className="text-xs text-secondary-300"> {pool.displayIncomePerEpoch}</div>
      </MessageBox>
    )
  }

  return (
    <MessageBox
      variant={"success"}
      className={cn("w-full justify-center whitespace-nowrap bg-p500 text-end", "h-full", "border-none")}
      showIcon={false}
    >
      <div className={"pb-1 text-t100"}>{pool.displayApr}</div>
      <div className="text-xs text-secondary-300"> {pool.displayIncomePerEpoch}</div>
    </MessageBox>
  )
})
